<div class="banner">
  <img [src]="imageSrc()" alt="" srcset="">
</div>
<div class="m-10">
  <h2>{{ title() }}</h2>
</div>
<div class="m-10">
  <p>{{ translate(description()) }}</p>
</div>
<div class="m-10">
  <jqxSwitchButton #pluginSwitchButton
    [width]="81" [height]="27" [checked]="isChecked(title())"
    (onChecked)="Checked(title())" (onUnchecked)="Unchecked(title())">
  </jqxSwitchButton>
</div>
